<section
  aria-labelledby="time-report-attachments-title"
  class="flex flex-col gap-3"
>
  <h3
    id="time-report-attachments-title"
    class="proffeo-ui-text-muted m-0"
  >
    {{ 'time-reports-form-modal-add-attachments' | translate }}
  </h3>

  @if (isAddingNewReport()) {
    <proffeo-ui-file-drop-zone (filesAdded)="onAddPreviewFiles($event)" />
    <proffeo-file-preview-list
      (removeFile)="onRemovePreviewFile($event)"
      [files]="previewFiles()"
    />
  } @else {
    <proffeo-ui-file-drop-zone (filesAdded)="onUploadFiles($event)" />
    <proffeo-file-horizontal-list
      (delete)="onDeleteFile($event)"
      [files]="files()"
      [uploadingFiles]="uploadingFiles()"
    />
  }
</section>
